export default __webpack_public_path__ + "static/media/getInspiredWelcomeText.e2643e89.png";